export default "Fly towards incident site, distance is approx. 100 Nm.<br />\n1 person on beach possible heart attack.";